/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, January 10th 2022, 4:32:56 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
import { NODE_TYPES } from "lib/schemas";
import { InlineIcon, IconProps } from "@iconify/react";
import BPMNStartEventIcon from "@iconify/icons-bpmn/start-event";
import BPMNUserIcon from "@iconify/icons-bpmn/user";
import BPMNCallActivityICon from "@iconify/icons-bpmn/call-activity";
import BPMNGatewayIcon from "@iconify/icons-bpmn/gateway";
import BPMNGatewayParallelIcon from "@iconify/icons-bpmn/gateway-parallel";
import BPMNEndEventIcon from "@iconify/icons-bpmn/end-event";
import BPMNServiceTaskIcon from "@iconify/icons-bpmn/service";
import BPMNSignalIcon from "@iconify/icons-bpmn/intermediate-event";

const BPMNIcon = ({ icon, ...props }) => <InlineIcon icon={icon} {...props} />;

export const AutoCreatedTaskTypes: Partial<keyof typeof NODE_TYPES>[] = ["StartFunction", "End"];

interface BPMNTaskTypeIconProps extends Omit<IconProps, "icon"> {
  taskType: keyof typeof NODE_TYPES;
}

export const BPMNTaskTypeIcon = ({ taskType, ...props }: BPMNTaskTypeIconProps) => {
  switch (taskType) {
    case "View":
      return <BPMNIcon className="os-user-task-icon" icon={BPMNUserIcon} {...props} />;
    case "StartFunction":
      return <BPMNIcon className="os-start-event-icon" icon={BPMNStartEventIcon} {...props} />;
    case "Handler":
      return <BPMNIcon className="os-automated-task-icon" icon={BPMNServiceTaskIcon} {...props} />;
    case "If":
      return <BPMNIcon className="os-if-gateway-icon" icon={BPMNGatewayIcon} {...props} />;
    case "Job":
      return <BPMNIcon className="os-scheduled-task-icon" icon={BPMNServiceTaskIcon} {...props} />;
    case "Join":
      return <BPMNIcon className="os-merge-node-icon" icon={BPMNGatewayParallelIcon} {...props} />;
    case "Signal":
      return <BPMNIcon className="os-signal-node-icon" icon={BPMNSignalIcon} {...props} />;
    case "Split":
      return <BPMNIcon className="os-split-node-icon" icon={BPMNGatewayParallelIcon} {...props} />;
    case "Switch":
      return <BPMNIcon className="os-switch-node-icon" icon={BPMNGatewayIcon} {...props} />;
    case "End":
      return <BPMNIcon className="os-end-task-icon" icon={BPMNEndEventIcon} {...props} />;
    case "Function":
      return <BPMNIcon className="os-automated-task-icon" icon={BPMNCallActivityICon} {...props} />;
  }
};
